// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080101/js/" + chunkId + "." + {"44":"da53807a","225":"983f1689","481":"242775db","486":"cb397726","770":"a1cfff3a"}[chunkId] + ".0.5012488880797048.chunk.js";
};